import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import ServerSideCarousel from '../../../../commonComponents/carousel/ServerSideCarousel';
import { useModal } from '../../../../services/customHooks';
import InboxMessagePlaceholder from './InboxMessage/InboxMessagePlaceholder';
import InboxMessageDetailsModal from './InboxMessage/InboxMessageDetailsModal';
import InboxMessage from './InboxMessage/InboxMessage';

export default function NewsSectionTab({ url }) {
  const [{ show: showDetailsModal, data: selectedMessage }, showModal] =
    useModal({ show: false, data: null });

  const handleSeeMore = useCallback(
    message => showModal({ show: true, data: message }),
    [showModal],
  );

  const hideModal = useCallback(
    () => showModal({ show: false, data: null }),
    [showModal],
  );

  return (
    <>
      {showDetailsModal && (
        <InboxMessageDetailsModal
          message={selectedMessage}
          onClose={hideModal}
        />
      )}
      <div className="m-portlet__body news-container" id="news-container">
        <ServerSideCarousel
          id="news-carousel"
          fetchUrl={url}
          defaultFetchError="error_fetchInbox"
          placeholder={<InboxMessagePlaceholder />}
        >
          {items =>
            items.map(message => (
              <InboxMessage
                key={message._id}
                message={message}
                onSeeMore={() => handleSeeMore(message)}
              />
            ))
          }
        </ServerSideCarousel>
      </div>
    </>
  );
}

NewsSectionTab.propTypes = {
  url: PropTypes.string.isRequired,
};
